<div class="layout-footer">
    <span class="font-medium ml-3 text-white">Copyright © {{ date }} Mindmuzik Media. All rights reserved.</span>
</div>
